import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMail, FiGlobe } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-black border-t border-gray-900 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <div className="flex items-center gap-4 mb-4">
              <img 
                src="https://d268zs2sdbzvo0.cloudfront.net/22144dca-44c9-40e5-bcaf-c785db45f372.png" 
                alt="Next Level Local" 
                className="w-32 h-auto"
              />
            </div>
            <div className="space-y-2">
              <div className="flex items-center gap-2 text-gray-400">
                <SafeIcon icon={FiMail} className="w-4 h-4" />
                <a 
                  href="mailto:contact@nextlevellocal.biz"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  contact@nextlevellocal.biz
                </a>
              </div>
              <div className="flex items-center gap-2 text-gray-400">
                <SafeIcon icon={FiGlobe} className="w-4 h-4" />
                <a 
                  href="https://nextlevellocal.biz"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  nextlevellocal.biz
                </a>
              </div>
              <p className="text-gray-500 text-sm">
                All rights reserved by Assistant @ Next Level Local
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="text-center md:text-right"
          >
            <motion.a
              href="https://buy.stripe.com/4gMeVe5Ep3Ml3CK9bk6Vq04"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-8 py-4 bg-gradient-to-r from-yellow-400 to-pink-500 text-black font-bold rounded-full hover:scale-105 transition-transform"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Start Your Free Trial
            </motion.a>
          </motion.div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;